/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  created_on: ['created_on:gte', 'created_on:lte'],
  expected_departure_on: ['expected_departure_on:gte', 'expected_departure_on:lte'],
  load_weight_min: 'load_weight:gte',
  load_weight_max: 'load_weight:lte',
  load_volume_min: 'load_volume:gte',
  load_volume_max: 'load_volume:lte',
  start_address_id: 'start_address.id:in',
  vehicle_id: 'vehicle.id:in',
  driver_user_id: 'driver_user.id:in',
  driver_user_2_id: 'driver_user_2.id:in',
  user_group_id: 'user_group.id:in',
}

export default parseFilterDataMapping
